/**
 * Are we running as an installed app (PWA window / future native shell)?
 * Installed users get the anonymous local-first workspace; plain browser
 * tabs are cloud-only and must sign in.
 *
 * `?standalone=1` is an explicit override for test harnesses and embedded
 * shells that can't set display-mode.
 */
export function isStandalone(): boolean {
  if (new URLSearchParams(location.search).has("standalone")) return true;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  if (window.matchMedia("(display-mode: window-controls-overlay)").matches) return true;
  if ((navigator as { standalone?: boolean }).standalone === true) return true;
  return false;
}
